export const COST_CENTER_INITIAL_FILTER_FIELDS = ['name', 'description', 'status']
